import { Nav } from 'react-bootstrap';
import { NavItemWrapper, NavWrapper } from './styles';
import { useMediaQuery } from 'react-responsive';

interface IProps {
    activeKey: string,
    isAdmin: boolean,
    isNkrLogin: boolean,
    centerId: number,
    recipientId?: number,
    recipientAlias: string,
    donorId?: number,
    rexmId?: number,
    matchHistoryId?: number
}

const RecipientNav = (props: IProps) => {
    const isBigScreen = useMediaQuery({ minDeviceWidth: 1824 });
    const hrefPrefix = !props.isAdmin ? `/center/${props.centerId}/recipient` : `/admin/recipient`;
    const { centerId, recipientId, donorId, rexmId, matchHistoryId } = props;

    return (
        <NavWrapper className='no-print' height='30px'>
            <div style={{ paddingTop: 10, backgroundColor: 'white', marginBottom: 20 }}>
                <Nav bsStyle="pills" activeKey={props.activeKey} className='recipient-pills'>
                    <NavItemWrapper eventKey='RECIPIENT-LIST' href={'/center/' + centerId + '/recipients'}>
                        List
                    </NavItemWrapper>

                    <NavItemWrapper eventKey='TRANSPLANTED-RECIPIENTS' href={'/center/' + centerId + '/recipients/transplanted-recipients'}>
                        Transplanted Recipients
                    </NavItemWrapper>

                    <NavItemWrapper eventKey='ORDER-BULK-CHEEK-SWABS' href={`/center/${centerId}/profile/cheek-swab-request`}>
                        Order Bulk Cheek Swabs
                    </NavItemWrapper>

                    <NavItemWrapper eventKey='ADD' href={'/center/' + centerId + '/donor/add'}>
                        Add
                    </NavItemWrapper>

                    {props.recipientId != 0 && (
                        <>
                            <NavItemWrapper eventKey='RECIPIENT-PROFILE' active={props.activeKey == "RECIPIENT-PROFILE"} href={'/center/' + centerId + '/recipient/' + recipientId + '/profile'}>
                                Edit Recipient [{props.recipientAlias != '' ? props.recipientAlias : 'loading'}]
                            </NavItemWrapper>

                            <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                            <NavItemWrapper active={props.activeKey == 'TOOLBOX'} eventKey='TOOLBOX' href={'/center/' + centerId + '/recipient/' + recipientId + '/toolbox'}>
                                Toolbox
                            </NavItemWrapper>

                            <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                            <NavItemWrapper active={props.activeKey == 'POTENTIAL-DONORS'} eventKey='POTENTIAL-DONORS' href={'/center/' + centerId + '/recipient/' + recipientId + '/potential-donors'}>
                                Pre-Selects [{props.recipientAlias != '' ? props.recipientAlias : 'loading'}]
                            </NavItemWrapper>


                            {props.activeKey == 'DONOR-FACT-SHEET' && (
                                <>
                                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>
                                    <NavItemWrapper active={props.activeKey == 'DONOR-FACT-SHEET'} eventKey='DONOR-FACT-SHEET' href={'/center/' + centerId + '/recipient/' + recipientId + '/donor-fact-sheet/' + donorId}>
                                        Donor Fact Sheet [{props.recipientAlias != '' ? props.recipientAlias : 'loading'}]
                                    </NavItemWrapper>
                                </>
                            )}

                            {props.activeKey == 'EPLET-MM' && (
                                <>
                                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>
                                    <NavItemWrapper active={props.activeKey == 'EPLET-MM'} eventKey='EPLET-MM' href={'/center/' + centerId + '/recipient/' + recipientId + '/eplet-mm/' + donorId}>
                                        Eplet Mismatch [{props.recipientAlias != '' ? props.recipientAlias : 'loading'}]
                                    </NavItemWrapper>
                                </>
                            )}

                            {(props.activeKey == 'EVALUATE-DONOR' || props.activeKey == 'EVALUATE-RECIPIENT-DONOR') && props.donorId != null && (
                                <>
                                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>
                                    <NavItemWrapper active={true} eventKey={props.activeKey} href={`${hrefPrefix}/${recipientId}/evaluate-donor/${donorId}`}>
                                        Evaluate Donor [{props.recipientAlias != '' ? props.recipientAlias : 'loading'}]
                                    </NavItemWrapper>
                                </>
                            )}

                            {props.activeKey == 'EVALUATE-REXM' && (
                                <>
                                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>
                                    <NavItemWrapper active={props.activeKey == 'EVALUATE-REXM'} eventKey='EVALUATE-REXM' href={`${hrefPrefix}/${recipientId}/rexm/${rexmId}`}>
                                        Request For Review [{props.recipientAlias != '' ? props.recipientAlias : 'loading'}]
                                    </NavItemWrapper>
                                </>
                            )}

                            {props.activeKey == 'EVALUATE-MATCH' && (
                                <>
                                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>
                                    <NavItemWrapper active={props.activeKey == 'EVALUATE-MATCH'} eventKey='EVALUATE-MATCH' href={`/center/${props.centerId}/recipient/evaluate-match/${matchHistoryId}`}>
                                        Evaluate Match [{props.recipientAlias != '' ? props.recipientAlias : 'loading'}]
                                    </NavItemWrapper>
                                </>
                            )}

                            {props.activeKey == 'WAITLIST-REPLACE' && (
                                <>
                                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>
                                    <NavItemWrapper active={props.activeKey == 'WAITLIST-REPLACE'} eventKey='EVALUATE-MATCH' href={`/center/${props.centerId}/recipient/${recipientId}`}>
                                        Replace Recipient [{props.recipientAlias != '' ? props.recipientAlias : 'loading'}]
                                    </NavItemWrapper>
                                </>
                            )}
                        </>
                    )}
                </Nav>
            </div>
        </NavWrapper>
    );
}

export default RecipientNav;